export default "__VITE_ASSET__BBw98Yg3__"